import * as ActiveStorage from "@rails/activestorage"
import "@hotwired/turbo-rails"
import "./controllers"
import { storeTekWrapped } from "./crypto"

import { StreamActions } from "@hotwired/turbo"

ActiveStorage.start()

StreamActions.redirect_to = function () {
  const url = this.getAttribute('url') || '/'
  Turbo.visit(url)
}

StreamActions.store_tek_and_redirect = async function () {
  const tekWrapped = this.getAttribute('tek-wrapped')
  const url = this.getAttribute('url') || '/'
  if (tekWrapped) {
    await storeTekWrapped(tekWrapped)
  }
  window.location.href = url
}

StreamActions.show_remote_modal = function () {
  const container = document.querySelector("modal")
  if (!container) return

  // the incoming template contains a <dialog> with content
  const incoming = this.templateContent
  const incomingDialog = incoming.querySelector("dialog")
  if (!incomingDialog) return

  // Existing dialog (if any)
  let dialog = container.querySelector("dialog")

  // If a dialog exists and is already open, only replace its *inner* content.
  if (dialog && dialog.open) {
    // Replace children inside the dialog without replacing the dialog element itself
    dialog.replaceChildren(...incomingDialog.cloneNode(true).children)
    return
  }

  // If there is no dialog (first open) or it's closed, replace the container content.
  container.replaceChildren(incomingDialog.cloneNode(true))

  // Open only if not already open
  dialog = container.querySelector("dialog")
  if (!dialog.open) dialog.showModal()
}

StreamActions.close_remote_modal = function () {
  const container = document.querySelector("modal")
  container.querySelector("dialog").close()
  setTimeout(() => container.replaceChildren(), 500)
}
